import { useState } from 'react';
import { ChevronDown } from 'lucide-react';

interface CollapsibleSectionProps {
    title: string;
    icon?: React.ReactNode;
    defaultOpen?: boolean;
    children: React.ReactNode;
    badge?: React.ReactNode;
}

export const CollapsibleSection = ({ title, icon, defaultOpen = false, children, badge }: CollapsibleSectionProps) => {
    const [isOpen, setIsOpen] = useState(defaultOpen);

    return (
        <div className="border-t border-line pt-4 mt-4 first:border-t-0 first:pt-0 first:mt-0">
            <button
                type="button"
                onClick={() => setIsOpen(!isOpen)}
                className="w-full flex items-center justify-between gap-2 py-2 group hover:text-accent transition-colors"
            >
                <div className="flex items-center gap-2">
                    {icon && <span className="text-fg-2 group-hover:text-accent transition-colors">{icon}</span>}
                    <h4 className="text-sm font-bold text-fg uppercase tracking-wider group-hover:text-accent transition-colors">
                        {title}
                    </h4>
                    {badge}
                </div>
                <ChevronDown
                    className={`w-4 h-4 text-fg-2 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}
                />
            </button>

            <div
                className={`grid transition-all duration-200 ease-in-out ${isOpen ? 'grid-rows-[1fr] opacity-100 mt-4' : 'grid-rows-[0fr] opacity-0'}`}
            >
                <div className="overflow-hidden">
                    {children}
                </div>
            </div>
        </div>
    );
};
